/*
 * @Description:
 * @Author: kai.zhou
 * @Date: 2020-03-09 16:30:27
 * @LastEditors: Mayer
 * @LastEditTime: 2024-01-04 10:58:45
 */

import React from "react";
import { HashRouter as Router } from "react-router-dom";
import { renderRoutes } from "assets/renderRouter";
import Loadable from "react-loadable"; //按需加载路由插件
import { Provider } from "react-redux";

const MyLoadingComponent = (v: { isLoading: any; error: any }) => {
  if (v.isLoading) {
    return <div>Loading...</div>;
  } else if (v.error) {
    return <div>Sorry, there was a problem loading the page.</div>;
  } else {
    return null;
  }
};
const Landing = Loadable({
  loader: () => import("../views/landing"),
  loading: MyLoadingComponent,
});

const PCLanding = Loadable({
  loader: () => import("./pclanding"),
  loading: MyLoadingComponent,
});

const routes = [
  {
    path: "/landing", //落地页
    component: Landing,
  },
  {
    path: "/pclanding", //落地页
    component: PCLanding,
  },
  
  {
    path: "/",
    redirect: "/landing",
  },
];

const mRoute = () => {
  return (
      <Router>{renderRoutes(routes)}</Router>
  );
};

export default mRoute;
